import Enum from '@/modules/core/app/helpers/Enum';

export class AnthropicModel extends Enum {
  key!: string;
  value!: string;

  static CLAUDE_3_5_SONNET_LATEST = {
    key: 'claude-3-5-sonnet-latest',
    get value(): string {
      return 'Claude 3.5 Sonnet';
    }
  };

  static CLAUDE_3_5_HAIKU_LATEST = {
    key: 'claude-3-5-haiku-latest',
    get value(): string {
      return 'Claude 3.5 Haiku';
    }
  };

  static CLAUDE_3_7_SONNET_LATEST = {
    key: 'claude-3-7-sonnet-latest',
    get value(): string {
      return 'Claude 3.7 Sonnet';
    }
  };

  static CLAUDE_3_OPUS_LATEST = {
    key: 'claude-3-opus-latest',
    get value(): string {
      return 'Claude 3 Opus';
    }
  };

  static CLAUDE_4_OPUS_LATEST = {
    key: 'claude-opus-4-0',
    get value(): string {
      return 'Claude 4 Opus';
    }
  };

  static CLAUDE_4_SONNET_LATEST = {
    key: 'claude-sonnet-4-0',
    get value(): string {
      return 'Claude 4 Sonnet';
    }
  };

  static CLAUDE_SONNET_4_5 = {
    key: 'claude-sonnet-4-5',
    get value(): string {
      return 'Claude Sonnet 4.5';
    }
  };

  static CLAUDE_HAIKU_4_5 = {
    key: 'claude-haiku-4-5',
    get value(): string {
      return 'Claude Haiku 4.5';
    }
  };

  static CLAUDE_OPUS_4_5 = {
    key: 'claude-opus-4-5',
    get value(): string {
      return 'Claude Opus 4.5';
    }
  };

  static CLAUDE_SONNET_4_6 = {
    key: 'claude-sonnet-4-6',
    get value(): string {
      return 'Claude Sonnet 4.6';
    }
  };

  static CLAUDE_OPUS_4_6 = {
    key: 'claude-opus-4-6',
    get value(): string {
      return 'Claude Opus 4.6';
    }
  };

  static CLAUDE_OPUS_4_7 = {
    key: 'claude-opus-4-7',
    get value(): string {
      return 'Claude Opus 4.7';
    }
  };

  static CLAUDE_OPUS_4_8 = {
    key: 'claude-opus-4-8',
    get value(): string {
      return 'Claude Opus 4.8';
    }
  };

  static CLAUDE_SONNET_5 = {
    key: 'claude-sonnet-5',
    get value(): string {
      return 'Claude Sonnet 5';
    }
  };
}
